<template>
  <div class="login-container">
    <div class="left">
      <div class="title">
        <img src="@/static/logo.png" alt="" class="logo" />
        <span>春风数字园区后台管理系统</span>
      </div>
      <div class="brief">数字园区<br />整体解决方案</div>
      <div class="sub">全新的理念 全新的模式</div>
    </div>
    <div class="right">
      <div class="hello">Hello!</div>
      <div class="subTitle">欢迎您登录数字园区管理系统</div>
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
        auto-complete="on"
        label-position="top"
        @submit.native.prevent
      >
        <el-form-item prop="username" label="账号">
          <el-input
            ref="username"
            v-model="loginForm.username"
            placeholder="请输入您的账号"
            name="username"
            type="text"
            tabindex="1"
            auto-complete="on"
          />
        </el-form-item>

        <el-form-item prop="password" label="密码">
          <el-input
            :key="passwordType"
            ref="password"
            v-model="loginForm.password"
            :type="passwordType"
            placeholder="请输入密码"
            name="password"
            tabindex="2"
            auto-complete="on"
            @keyup.enter.native="handleLogin"
          />
          <!-- <span class="show-pwd" @click="showPwd">
          <svg-icon
            :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'"
          />
        </span> -->
        </el-form-item>
        <el-form-item prop="auth_code" label="验证码">
          <br />
          <div class="codeBox">
            <el-input
              class="code"
              ref="auth_code"
              v-model="loginForm.auth_code"
              placeholder="请输入验证码"
              name="auth_code"
              type="text"
              tabindex="1"
              auto-complete="on"
              @keyup.enter.native="handleLogin"
            />
            <!-- <img class="codeImg" :src="@/static/logoBg.png" alt=""> -->
            <img
              ref="vcImg"
              class="codeImg"
              :src="Captcha"
              alt=""
              @click="getVerifyCode()"
            />
          </div>
        </el-form-item>

        <el-button
          :loading="loading"
          type="primary"
          style="width: 100%; margin-bottom: 30px"
          @click.native.prevent="handleLogin"
          >登 录</el-button
        >
      </el-form>
    </div>
  </div>
</template>

<script>
// import  '@/utils/rem'
import resetRem from "@/utils/rem";

import { validUsername, validatePassword } from "@/utils/validate";
import { getCaptcha } from "@/api/user";
export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
        auth_code: "",
      },
      loginRules: {
        username: [{ required: false, trigger: "blur" }],
        password: [{ required: false, trigger: "blur" }],
      },
      loading: false,
      passwordType: "password",
      redirect: undefined,
      Captcha: "",
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {
    resetRem();
    this.getVerifyCode();
  },
  mounted() {
    // remConfig();
    window.onresize = () => {
      return (() => {
        this.$nextTick(() => {
          resetRem();
        });
      })();
    };
  },
  methods: {
    // 重新获取表单验证码
    getVerifyCode() {
      getCaptcha().then((response) => {
        this.Captcha = response;
        // const blob = this.response
      });
      // 直接通过src去请求验证码图片 通过Math.random()防止缓存问题
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          // this.$store.dispatch('user/login', this.loginForm)
          // login(this.loginForm)
          this.$store
            .dispatch("user/login", this.loginForm)
            .then(() => {
              this.$router.push({ path: this.redirect || "/" });
              window.location.reload();
              this.loading = false;
            })
            .catch(() => {
              this.getVerifyCode();
              this.loading = false;
            });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #fff;
$light_gray: #000;
$cursor: #000;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 436px;

    input {
      background: transparent;
      // border: 0px;
      -webkit-appearance: none;
      // border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 10px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 0.01px solid rgba(255, 255, 255, 0.1);
    // background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  min-height: 100vh;
  min-width: 1360px;
  width: 100%;
  background: url("../../static/logoBg.jpg") no-repeat;
  background-size: 100% 100%;
  // background-color: $bg;
  overflow: auto;
  box-sizing: border-box;
  display: flex;
  .left {
    padding-left: 92px;
    padding-top: 68px;
    width: 62.97%;
    .title {
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 45px;
      display: flex;
      .logo {
        width: 42px;
        height: 50px;
        margin-right: 16px;
      }
    }
    .brief {
      font-size: 52px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 73px;
      margin-top: 240px;
    }
    .sub {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 33px;
      margin-top: 16px;
    }
  }

  .right {
    max-width: 37.03%;
    height: 100%;
    box-sizing: border-box;
    background: #ffffff;
    padding: 17.39vh 5vw;
    .hello {
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 45px;
    }
    .subTitle {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 33px;
    }
  }

  .tips {
    // font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 06px 05px 06px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 07px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}
.codeBox {
  display: flex;
  justify-content: space-between;
  float: left;
  .code {
    width: 250px;
  }
  .codeImg {
    width: 177px;
    height: 47px;
  }
}
::v-deep .el-form--label-top .el-form-item__label {
  float: left;
}
.login-form {
  margin-top: 58px;
}
.myAge {
  font-size: 20px !important;
}
</style>
